/** @format */

import {styled} from '@mui/material/styles';
import {TableCell, TableCellProps} from '@mui/material';

const StyledTableCell = styled((props: TableCellProps) => <TableCell {...props} />)(({theme}) => ({
  height: '36px',
  padding: theme.spacing(1, 2),
  borderBottom: 'none',
}));

export {StyledTableCell};
